import React, { useCallback, useEffect, useState } from 'react';
import { ISnackbarAlert, SelectField, TextFieldInput } from '../../../shared/components';
import { Grid, Icon, IconButton, Tooltip, Typography } from '@mui/material';
import { AssociatedSkillDTO, AssociatedSkillFilterDTO, ValueListDTO } from '../../../shared/interfaces';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { useTranslation } from 'react-i18next';

interface DynamicComboBoxPairProps {
    title: string;
    ownerId: string;
    skillType: 'hardSkill' | 'softSkill' | 'language';
    isMandatory: boolean;
    hasValidated: boolean | false
}

export const DynamicComboBoxPair: React.FC<DynamicComboBoxPairProps> = ({ title, ownerId, skillType, isMandatory, hasValidated }) => {

    const [skillList, setSKillList] = useState<ValueListDTO[]>([]);
    const [seniorityList, setSeniorityList] = useState<ValueListDTO[]>([]);
    const [associatedSkillDTO, setAssociatedSkillDTO] = useState<AssociatedSkillDTO>();
    const [associatedSkillUpdateDTO, setAssociatedSkilUpdatelDTO] = useState<AssociatedSkillDTO>();
    const [associatedSkillList, setAssociatedSkillList] = useState<AssociatedSkillDTO[]>([]);

    const [actionExecuted, setActionExecuted] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setAssociatedSkillDTO({
            id: '',
            ownerId: ownerId,
            typeId: skillType === 'hardSkill' ? ListId.talentsphere.associatedSkill.hardSkillId : skillType === 'softSkill' ? ListId.talentsphere.associatedSkill.softSkillId : ListId.talentsphere.associatedSkill.languageId,
            skillId: '',
            seniorityId: '',
            experienceTime: '',
            isMandatory: isMandatory,
            isValidated: false
        } as AssociatedSkillDTO);

        if(ownerId){
            if (skillType == 'hardSkill'){
                handleListGetAll(ListId.talentsphere.associatedSkill.hardSkillId, setSKillList, 'value ASC');
                handleListGetAll(ListId.talentsphere.vacancy.seniorityId, setSeniorityList, 'valueIndex ASC');
            }

            if (skillType == 'softSkill'){
                handleListGetAll(ListId.talentsphere.associatedSkill.softSkillId, setSKillList, 'value ASC');
                handleListGetAll(ListId.talentsphere.associatedSkill.expertiseId, setSeniorityList, 'valueIndex ASC');
            }

            if (skillType == 'language'){
                handleListGetAll(ListId.talentsphere.associatedSkill.languageId, setSKillList, 'value ASC');
                handleListGetAll(ListId.talentsphere.associatedSkill.languageLevelId, setSeniorityList, 'valueIndex ASC');
            }

            handleAssociatedSkillGetAllAsync(setAssociatedSkillList);
        }
    }, [ownerId, actionExecuted]);

    useEffect(() => {
        if (actionExecuted)
            handleAssociatedSkillGetAllAsync(setAssociatedSkillList);
    }, [actionExecuted]);

    const handleListGetAll = useCallback(async (listId: string, setList: any, orderBy: string) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: orderBy
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage,
            false
        );
    }, []);

    const handleAssociatedSkillGetAllAsync = useCallback(async (setList: any) => {
        const associatedSKillFilterDTO: AssociatedSkillFilterDTO = {
            ownerId: ownerId,
            typeId: skillType === 'hardSkill' ? ListId.talentsphere.associatedSkill.hardSkillId : skillType === 'softSkill' ? ListId.talentsphere.associatedSkill.softSkillId : ListId.talentsphere.associatedSkill.languageId,
            skillId: '',
            seniorityId: '',
            isMandatory: isMandatory
        };
        GenericService.GetAllViewAsync1('talentsphere.associatedSkill', associatedSKillFilterDTO, setActionExecuted, setLoading, setAssociatedSkillList, showMessage, false);

    }, []);

    const handleSaveClick = useCallback(async () => {
        const dto = associatedSkillDTO as AssociatedSkillDTO;

        if (associatedSkillDTO?.id === '' || associatedSkillDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('talentsphere.associatedSkill', dto, setAssociatedSkillDTO, setActionExecuted, setLoading, showMessage);
            setAssociatedSkillDTO({
                id: '',
                ownerId: ownerId,
                typeId: skillType === 'hardSkill' ? ListId.talentsphere.associatedSkill.hardSkillId : skillType === 'softSkill' ? ListId.talentsphere.associatedSkill.softSkillId : ListId.talentsphere.associatedSkill.languageId,
                skillId: '',
                seniorityId: '',
                experienceTime: '',
                isMandatory: isMandatory,
                isValidated: false
            } as AssociatedSkillDTO);
        }
    }, [associatedSkillDTO]);

    const updateAndSaveAssociation = async (index: number, field: any, value: any) => {

        const updatedList = associatedSkillList.map((skill, idx) => {
            if (idx === index) {
                return { ...skill, [field]: value };
            }
            return skill;
        });
        setAssociatedSkillList(updatedList);

        const updatedSkill = updatedList[index];
        setAssociatedSkilUpdatelDTO(updatedSkill);

        updatedSkill.isValidated = false;
        updatedSkill.ownerId = ownerId;
        updatedSkill.typeId = skillType === 'hardSkill' ? ListId.talentsphere.associatedSkill.hardSkillId : skillType === 'softSkill' ? ListId.talentsphere.associatedSkill.softSkillId : ListId.talentsphere.associatedSkill.languageId;
        updatedSkill.isMandatory = isMandatory;
        updatedSkill.updatedById = userInfo.user.id;
        GenericService.UpdateAsync1('talentsphere.associatedSkill', updatedSkill, setActionExecuted, setLoading, showMessage);
    };

    const HandleValidateAssociation = async (index: number, field: any, value: any) => {

        const updatedList = associatedSkillList.map((skill, idx) => {
            if (idx === index) {
                return { ...skill, [field]: value };
            }
            return skill;
        });
        setAssociatedSkillList(updatedList);

        const updatedSkill = updatedList[index];
        setAssociatedSkilUpdatelDTO(updatedSkill);

        updatedSkill.isValidated = !value;
        updatedSkill.ownerId = ownerId;
        updatedSkill.typeId = skillType === 'hardSkill' ? ListId.talentsphere.associatedSkill.hardSkillId : skillType === 'softSkill' ? ListId.talentsphere.associatedSkill.softSkillId : ListId.talentsphere.associatedSkill.languageId;
        updatedSkill.isMandatory = isMandatory;
        updatedSkill.updatedById = userInfo.user.id;
        GenericService.UpdateAsync1('talentsphere.associatedSkill', updatedSkill, setActionExecuted, setLoading, showMessage);
    };

    const deleteAssociation = (index: number, id: string) => {
        setAssociatedSkillList(associatedSkillList.filter((_, idx) => idx !== index));

        GenericService.DeleteAsync1('talentsphere.associatedskill', id, setLoading, setAssociatedSkilUpdatelDTO, showMessage);
    };

    const getAvailableSkills = () => {
        return skillList.filter(skill => !associatedSkillList.some(associatedSkill => associatedSkill.skillId === skill.id));
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    return (
        <React.Fragment>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                <Tooltip title={''} placement={'bottom-start'}>
                    <Typography variant="button" component="div" >
                        {title}
                    </Typography>
                </Tooltip>
            </div>
            {associatedSkillList.map((skill, index) => (
                <div key={index} style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='skillId'
                                label={t('vacancy.dynamicComboBoxPair.selectField.skill')}
                                value={skill.skillId}
                                setValue={(value) => updateAndSaveAssociation(index, 'skillId', value)}
                                obj={null} // Removido, já que agora estamos passando diretamente o valor
                                valueList={skillList}
                                searchable={true}
                                valueKey='id'
                                labelKey={'value'}
                            // Outras props
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <SelectField
                                id='seniorityId'
                                label={t('vacancy.dynamicComboBoxPair.selectField.seniority')}
                                value={skill.seniorityId}
                                setValue={(value) => updateAndSaveAssociation(index, 'seniorityId', value)}
                                obj={null}
                                valueList={seniorityList}
                                hasNoneSelect={false}
                            // Outras props
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='experienceTime'
                                label={t('vacancy.dynamicComboBoxPair.selectField.experienceTime')}
                                value={skill.experienceTime}
                                setValue={(value) => updateAndSaveAssociation(index, 'experienceTime', value)}
                                obj={null}
                                required={false}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Tooltip title={t('vacancy.dynamicComboBoxPair.tooltip.delete')}>
                                <IconButton
                                    id={'delete'}
                                    size='small'
                                    onClick={() => deleteAssociation(index, skill.id)}
                                >
                                    <Icon fontSize='small' color={'error'}>{'delete_outlined'}</Icon>
                                </IconButton>
                            </Tooltip>
                            {hasValidated ? (
                                <Tooltip title={skill.isValidated ? t('vacancy.dynamicComboBoxPair.tooltip.validated') : t('vacancy.dynamicComboBoxPair.tooltip.noValidated')}>
                                    <IconButton
                                        id={'validate'}
                                        size='small'
                                        onClick={() => HandleValidateAssociation(index, 'isValidated', skill.isValidated)}
                                    >
                                        <Icon fontSize='small' color={skill.isValidated? 'success' : 'error'}>{skill.isValidated? 'check_outlined' : 'close_outlined'}</Icon>
                                    </IconButton>
                                </Tooltip>
                            ) : undefined}
                        </Grid>
                    </Grid>
                </div>
            ))}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <SelectField
                            id='skillId'
                            label={t('vacancy.dynamicComboBoxPair.selectField.skill')}
                            value={associatedSkillDTO?.skillId}
                            setValue={setAssociatedSkillDTO}
                            obj={associatedSkillDTO}
                            valueList={skillList}
                            hasNoneSelect={true}
                            searchable={true}
                            valueKey='id'
                            labelKey={'value'}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SelectField
                            id={'seniorityId'}
                            label={t('vacancy.dynamicComboBoxPair.selectField.seniority')}
                            value={associatedSkillDTO?.seniorityId}
                            setValue={setAssociatedSkillDTO}
                            obj={associatedSkillDTO}
                            valueList={seniorityList}
                            hasNoneSelect={false}
                            searchable={true}
                            valueKey='id'
                            labelKey={'value'}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextFieldInput
                            id='experienceTime'
                            label={t('vacancy.dynamicComboBoxPair.selectField.experienceTime')}
                            value={associatedSkillDTO?.experienceTime}
                            setValue={setAssociatedSkillDTO}
                            obj={associatedSkillDTO}
                            required={false}
                            maxLength={200}
                        />
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Tooltip title={t('vacancy.dynamicComboBoxPair.tooltip.addNewSkill')}>
                            <IconButton
                                size='small'
                                onClick={handleSaveClick}
                            >
                                <Icon fontSize='medium' color={'success'}>{'add_circle_outlined'}</Icon>
                            </IconButton>
                        </Tooltip>
                    </Grid>

                </Grid>

            </div>
        </React.Fragment>
    );
};
